
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {Button, Card, CardBody, CardHeader, Container, Form} from "reactstrap";
import ContentService from "../../../services/xgContentService";
import ContentForm from "./Form";
import {contentCategory} from "../../../util/contentCategory";
import {contentType} from "../../../util/contentType";
import {contentArticleType} from "../../../util/contentArticleType";
import _ from "lodash";
import MeetingForm from "./Form";
import UtilService from "../../../services/utilService";
import CompanyService from "../../../services/companyService";
import ContactService from "../../../services/contactService";
import MeetingReportService from "../../../services/meetingReportService";

class MeetingCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorData: {},
            eventType: 'CALL',
            attendees: [],
            companySuggestions: [],
            companyList: [], // This should be populated with company data from your database
            contacts: [], // This should be populated based on the selected company
            companySelectKey: UtilService.uuidv4(),
            attendeesSelectKey: UtilService.uuidv4(),
            attendeesForSelection : [],
            allContacts : [],
            selectedEventType:{},
            selectedAttendees: [],
            companyUniqueId : this.props.match.params.companyId || null
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCompanyChange = this.handleCompanyChange.bind(this);
        this.handleAttendeesChange = this.handleAttendeesChange.bind(this);
        this.handleEventTypeChange = this.handleEventTypeChange.bind(this);
    }


    componentDidMount() {
        const {companyId} = this.props.match.params;
        console.log(this.props)
        CompanyService.list().then((response) => {
            console.log(response);
            this.setState({companyList: response, companySelectKey :UtilService.uuidv4() });
        });
        ContactService.list().then((response) => {
            console.log(response);
            this.setState({allContacts: response, attendeesSelectKey :UtilService.uuidv4() });
            const uniqueId = this.state.companyUniqueId || null
            console.log(uniqueId)
            if(this.state.companyUniqueId !== null){
                const selectedCompany = _.find(this.state.companyList, company => company.uniqueId === uniqueId)
                console.log(selectedCompany);
                if(selectedCompany) {
                    const filteredContacts = _.filter(this.state.allContacts, (contact) => contact?.company?.uniqueId === selectedCompany.uniqueId);
                    this.setState({selectedCompany: selectedCompany,
                        companyUID : selectedCompany.uniqueId,
                        attendeesForSelection: filteredContacts,
                        attendees : [],
                        selectedAttendees : [],
                        companySelectKey: UtilService.uuidv4(),
                        attendeesSelectKey: UtilService.uuidv4()
                    });
                }
            }
        });
        console.log("Component did mount")
        console.log(this.state)
    }

    handleCompanyChange = (valueObj, event) => {
        console.log(valueObj);
        if (_.isNull(valueObj)) {
            this.setState({selectedCompany: {}, companyId :"", attendees : []});
        } else {
            const filteredContacts = _.filter(this.state.allContacts, (contact) => contact.company.uniqueId === valueObj.uniqueId);
            console.log(filteredContacts)
            this.setState({selectedCompany: valueObj,
                companyUID : valueObj.uniqueId,
                attendeesForSelection: filteredContacts,
                attendees : [],
                selectedAttendees : [],
                attendeesSelectKey: UtilService.uuidv4()
            });
        }
        this.setState({ companyName: valueObj.legalName });

    };


    handleEventTypeChange = (valueObj,event) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedEventType : {}, eventType:  ""});
        } else {
            this.setState({ selectedEventType : valueObj, eventType: valueObj.key});
        }
    }

    handleAttendeesChange = (valueObj,event) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedAttendees: []});
        } else {
            this.setState({selectedAttendees: valueObj});
            const attendees = _.map(valueObj, "uniqueId")
            this.setState({attendees: attendees});
        }
    };




// =====================
    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }


    handleSubmit(event) {
        event.preventDefault();
        console.log(this.state)
        MeetingReportService.create(this.state).then(response => {
            console.log(response.data);
            if (response.responseStatus === "SUCCESS") {
                this.props.history.push(`/crm/meetingReport/show/${response.data.uniqueId}`);
            } else {
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }


    render() {
        return (
            <>
                <SimpleHeader
                    name="Create"
                    parentName="Meeting"
                    heading="XareGrowth"
                    newBtnUrl="/crm/meetingReport/list"
                    newBtnText="List Meetings"
                />
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">Create Meeting</h3>
                        </CardHeader>
                        <CardBody>
                            <Form role="form" onSubmit={this.handleSubmit}>
                                <MeetingForm
                                    onChange={this.handleChange}
                                    valueObj={this.state}
                                    errorObj={this.state.errorData}

                                    companySelectKey={ this.state.companySelectKey}
                                    handleCompanyChange={this.handleCompanyChange}
                                    selectedCompany = {this.state.selectedCompany}
                                    companyList = {this.state.companyList}

                                    attendeesSelectkey={this.state.attendeesSelectKey}
                                    handleAttendeesChange={this.handleAttendeesChange}
                                    selectedAttendees={this.state.selectedAttendees}
                                    attendeesForSelection={this.state.attendeesForSelection}

                                    handleEventTypeChange={this.handleEventTypeChange}
                                    selectedEventType={this.state.selectedEventType}


                                />
                                <div className="text-center">
                                    <Button className="my-4" color="default" outline type="submit">
                                        Submit
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Container>
            </>
        );
    }
}

export default MeetingCreate;
